var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { PriceStatusClass } from "../../data/models";
import { observer } from "mobx-react";
var baseClass = "rj-winnings";
var Winnings = /** @class */ (function (_super) {
    __extends(Winnings, _super);
    function Winnings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Winnings.prototype.renderCurrent = function (data) {
        var fadingClass = this.props.onStakeChangeFading ? " " + baseClass + "__item--fading-winnings" : "";
        return (React.createElement("div", { key: baseClass + "-" + data.periodNumber, className: baseClass + "__item" + (" " + baseClass + "__item--" + PriceStatusClass.periodCurrent) + fadingClass, "data-atr": data.status },
            React.createElement("div", { className: baseClass + "__item-inner" },
                React.createElement("span", { className: baseClass + "__sum" }, data.winningValue))));
    };
    Winnings.prototype.renderWithoutClass = function (data) {
        var fadingClass = this.props.onStakeChangeFading ? " " + baseClass + "__item--fading-winnings" : "";
        return (React.createElement("div", { key: baseClass + "-" + data.periodNumber, className: baseClass + "__item" + fadingClass, "data-atr": data.status },
            React.createElement("div", { className: baseClass + "__item-inner" },
                React.createElement("span", { className: baseClass + "__sum" }, data.winningValue))));
    };
    Winnings.prototype.renderResulting = function (data) {
        var fadingClass = this.props.onStakeChangeFading ? " " + baseClass + "__item--fading-winnings" : "";
        return (React.createElement("div", { key: baseClass + "-" + data.periodNumber, className: baseClass + "__item" + (" " + baseClass + "__item--" + PriceStatusClass.periodResulting) + fadingClass, "data-atr": data.status },
            React.createElement("div", { className: baseClass + "__item-inner" },
                React.createElement("span", { className: baseClass + "__sum" }, data.winningValue))));
    };
    Winnings.prototype.renderPreperiod = function (data) {
        var fadingClass = this.props.onStakeChangeFading ? " " + baseClass + "__item--fading-winnings" : "";
        return (React.createElement("div", { key: baseClass + "-" + data.periodNumber, className: baseClass + "__item" + (" " + baseClass + "__item--" + PriceStatusClass.periodPre) + fadingClass, "data-atr": data.status },
            React.createElement("div", { className: baseClass + "__item-inner" },
                React.createElement("span", { className: baseClass + "__sum" }, data.winningValue))));
    };
    Winnings.prototype.renderPeriodOver = function (data) {
        var fadingClass = this.props.onStakeChangeFading ? " " + baseClass + "__item--fading-winnings" : "";
        return (React.createElement("div", { key: baseClass + "-" + data.periodNumber, className: baseClass + "__item" + (" " + baseClass + "__item--" + PriceStatusClass.periodOver) + fadingClass, "data-atr": data.status },
            React.createElement("div", { className: baseClass + "__item-inner" },
                React.createElement("span", { className: baseClass + "__sum" }, data.winningValue))));
    };
    Winnings.prototype.renderWinning = function (status) {
        switch (status.winningStatus) {
            case 0:
                return this.renderPreperiod(status);
            case 1:
                return this.renderCurrent(status);
            case 2:
                return this.renderResulting(status);
            case 3:
                return this.renderPeriodOver(status);
        }
        return this.renderWithoutClass(status);
    };
    Winnings.prototype.render = function () {
        return (React.createElement("div", { className: baseClass + "__items-holder" }, this.props.inputData.winnings.map(this.renderWinning, this)));
    };
    Winnings = __decorate([
        observer
    ], Winnings);
    return Winnings;
}(React.Component));
export { Winnings };
//# sourceMappingURL=Winnings.js.map